import React from 'react'

import classnames from 'classnames'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { s2e } from '@kolayyolla/common/utils/helpers'

import { useQuery } from '@kolayyolla/shared/customHooks'

import { Tabs, Tab } from '@mui/material'
import { green } from '@mui/material/colors'
import { makeStyles, withStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => {
  const classList = {
    chipList: {

      '& .category': {
        scrollSnapAlign: 'end',
        display: 'flex',
        alignItems: 'flex-end',
        width: 'clamp(100px, 15vw, 150px)',
        height: 'clamp(75px, 10vw, 100px)',
        borderRadius: 8,
        boxShadow: '0px 1px 5px 0px rgba(50, 50, 50, 0.63)',
        padding: 8,
        flexShrink: 0,
        textAlign: 'center',
        justifyContent: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        color: 'white',
        fontWeight: 'bold',
        fontSize: 'clamp(10px, 1vw, 13px)',
        cursor: 'pointer'
      }

    },

    selected: {
      border: `3px solid ${green[500]}!important`,
      boxShadow: `${green[500]} 0px 2px 8px!important`
    },
    slider: {
      margin: theme.spacing(1)
    }
  }
  return classList
})

const ProductTypeTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    background: theme.palette.background.paper,
    margin: 6,
    padding: 4,
    opacity: 1
  }
}))((props) => <Tab {...props} />)

const CategoriesComponent = () => {
  const classes  = useStyles()
  const category = useSelector((state) => state.category)
  const navigate = useNavigate()
  const query    = useQuery()

  return (
    <Tabs
      value={0}
      className={classes.chipList}
      indicatorColor="primary"
      textColor="inherit"
      variant="scrollable"
      scrollButtons="auto"
      TabIndicatorProps={{
        hidden: true
      }}
    >
      {
        category.data.map((c) => (
          <ProductTypeTab
            key={c.key}
            label={(
              <div
                className={classnames('category', c.key === query.get('category') && classes.selected)}
                style={{ backgroundImage: `linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(0,0,0,0.60) 70%), url(${c.image?.md})` }}
              >
                {c.name}
              </div>
            )}
            onClick={() => {
              // if already Selected
              if (query.get('category') === c.key) {
                query.delete('category')
                navigate({
                  pathname: './',
                  search: query.toString()
                })
              } else {
                query.delete('category')
                query.append('category', s2e(c.name))
                navigate({
                  pathname: './',
                  search: query.toString()
                })
              }
            }}
          />
        ))
    }
    </Tabs>
  )
}

export default CategoriesComponent
